import app_logo from '@/assets/appLogoFull.png';
import { ApiProvider } from '@/provider/ApiProvider';
import { Grid, TextField } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Container from '@mui/material/Container';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import FormControlLabel from '@mui/material/FormControlLabel';
import Slide from '@mui/material/Slide';
import Typography from '@mui/material/Typography';
import { updatePassword } from 'aws-amplify/auth';
import serialize from 'form-serialize';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='left' ref={ref} {...props} />;
});

export default function SimpleMenu(props) {
  const [open, setOpen] = React.useState(false);
  const [old_password, set_old_password] = React.useState(false);
  const [new_password, set_new_password] = React.useState(false);
  const [confirm_password, set_confirm_password] = React.useState(false);
  const [form_submitted, set_form_submitted] = React.useState(false);
  const [checked, set_checkbox] = React.useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (props.openpopup == 'reset_password') {
      set_old_password('');
      set_new_password('');
      set_confirm_password('');
      document.getElementById('old_password' + props.sendpagename).type = 'password';
      document.getElementById('new_password' + props.sendpagename).type = 'password';
      document.getElementById('confirm_password' + props.sendpagename).type = 'password';
      document.getElementById('old_password' + props.sendpagename).value = '';
      document.getElementById('new_password' + props.sendpagename).value = '';
      document.getElementById('confirm_password' + props.sendpagename).value = '';
      set_checkbox(false);
      setOpen(true);
    }
  }, [props.openpopup]);

  const handleClose = () => {
    setOpen(false);
  };

  const savehandleClose = () => {
    var form = document.querySelector('#reset_password_form' + props.sendpagename);
    var obj = serialize(form, { hash: true });

    let body = new FormData();
    let isValid = true;

    if (!obj) {
      set_old_password('Please enter old password');
      set_new_password('Please enter new password');
      set_confirm_password('Please enter confirm password');

      return false;
    }

    if (!obj.old_password) {
      set_old_password('Please enter password');
      isValid = false;
    } else {
      set_old_password('');
    }

    if (!obj.new_password) {
      set_new_password('Please enter new password');
      isValid = false;
    } else if (obj.new_password.length < 8) {
      set_new_password('Password must be at least 8 characters.');
      isValid = false;
    } else {
      set_new_password('');
    }

    if (!obj.confirm_password) {
      set_confirm_password('Please enter confirm password');
      isValid = false;
    } else {
      set_confirm_password('');
    }

    if (obj.old_password && obj.new_password && obj.confirm_password && isValid == true) {
      if (obj.new_password === obj.old_password) {
        set_new_password('New password must be different from your current password');
        isValid = false;
      } else if (obj.new_password != obj.confirm_password) {
        set_new_password('Password and confirm password should be same');
        set_confirm_password('Password and confirm password should be same');
        isValid = false;
      } else {
        set_new_password('');
        set_confirm_password('');
      }
    }

    if (!isValid) {
      return false;
    }

    body.append('old_password', obj.old_password);
    body.append('new_password', obj.new_password);
    body.append('confirm_password', obj.confirm_password);

    set_form_submitted(true);

    // Use Amplify to change the Cognito password directly.
    // This verifies the old password against Cognito and sets the new one atomically.
    updatePassword({ oldPassword: obj.old_password, newPassword: obj.new_password })
      .then(async () => {
        set_form_submitted(false);
        ApiProvider.globalToastMessage(
          'Password changed successfully. Please log in again.',
          5000,
          'success',
        );
        setOpen(false);
        // Revoke all local gateway sessions after password change (best-effort),
        // then sign out of Cognito globally.
        try {
          const body = new FormData();
          body.append('all_sessions', '1');
          const refreshToken = localStorage.getItem('refresh_token');
          if (refreshToken) {
            body.append('refresh_token', refreshToken);
          }
          await ApiProvider.webservicePostToken('Logout', body, 'yes', null, {
            suppressUnauthorizedRedirect: true,
          });
        } catch (error) {
          // Continue with client/Cognito sign-out.
        }
        // logoutUserLocally clears localStorage synchronously before calling
        // signOut. With OAuth configured, signOut redirects to Cognito /logout
        // then back to the app — passing true lets it handle the fallback
        // navigate for non-OAuth environments.
        await ApiProvider.logoutUserLocally(true, { globalSignOut: true });
      })
      .catch((error) => {
        set_form_submitted(false);
        const msg =
          error.name === 'NotAuthorizedException'
            ? 'Current password is incorrect.'
            : error.message || 'Failed to change password. Please try again.';
        ApiProvider.globalToastMessage(msg, 6000, 'error');
      });
  };

  const handleChange = (event) => {
    set_checkbox(event.target.checked);
  };

  return (
    <div>
      <Dialog
        className='right_modal'
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby='alert-dialog-slide-title'
        aria-describedby='alert-dialog-slide-description'
      >
        <DialogContent>
          <form id={'reset_password_form' + props.sendpagename}>
            <div className=''>
              <Container maxWidth='xs'>
                <Grid container spacing={3}>
                  <Grid size={12}>
                    <Grid container spacing={2} className='text_align_center'>
                      <Grid size={12}>
                        <img className='login_LogoImage' src={app_logo} alt='Logo' />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Box mt={4} mb={2}>
                  <Grid container spacing={2}>
                    <Grid size={12}>
                      <Grid container spacing={2}>
                        <Grid className='text_center' size={12}>
                          <Typography variant='h5' style={{ fontSize: '1.25rem' }}>
                            Set new password
                          </Typography>
                        </Grid>
                        <Grid className='text_center' size={12}>
                          <Typography variant='body2'>
                            You can change default password by setting a new one
                          </Typography>
                        </Grid>
                        <Grid size={12}>
                          <TextField
                            className='full-width'
                            label='Current password'
                            variant='outlined'
                            name='old_password'
                            id={'old_password' + props.sendpagename}
                            type={checked ? 'text' : 'password'}
                          />
                          <div className='invalid-feedback'>{old_password}</div>
                        </Grid>
                        <Grid size={12}>
                          <TextField
                            className='full-width'
                            label='Create password'
                            variant='outlined'
                            name='new_password'
                            id={'new_password' + props.sendpagename}
                            type={checked ? 'text' : 'password'}
                          />
                          <Typography variant='caption' className='p_left'>
                            At least 8 characters, with uppercase, lowercase, number and special
                            character
                          </Typography>
                          <div className='invalid-feedback'>{new_password}</div>
                        </Grid>
                        <Grid size={12}>
                          <TextField
                            className='full-width'
                            label='Confirm password'
                            variant='outlined'
                            name='confirm_password'
                            id={'confirm_password' + props.sendpagename}
                            type={checked ? 'text' : 'password'}
                          />
                          <div className='invalid-feedback'>{confirm_password}</div>
                        </Grid>
                        <Grid size={6}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                color='secondary'
                                onChange={handleChange}
                                checked={checked}
                              />
                            }
                            label='Show password'
                          />
                        </Grid>
                        <Grid className='flex_center' size={3}>
                          <Button color='secondary' onClick={handleClose}>
                            Cancel
                          </Button>
                        </Grid>
                        <Grid className='flex_center' size={3}>
                          <Button
                            color='secondary'
                            disabled={form_submitted}
                            variant='contained'
                            onClick={savehandleClose}
                          >
                            {(form_submitted && 'Please Wait') || (!form_submitted && 'Save')}
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Box>
              </Container>
            </div>
          </form>
        </DialogContent>
      </Dialog>
    </div>
  );
}
